// Route options pop-up: used by dispatch (for one driver or every driver today), by drivers for their own
// route, and in Settings for a person's everyday defaults.
import { S, driverName, workingDrivers, routeOpt } from '../store.js';
import { esc, resolveOptions, labDefaults } from '../util.js';
import { modal } from './common.js';

export { routeOpt };

/** Short description, like "Farthest first, fewest miles, no tolls, ends at last stop". */
export function optSummary(o) {
  return [o.style === 'farthest' ? 'Farthest first' : 'Best order', o.fastest ? 'fastest' : 'fewest miles',
    o.hours ? 'office hours' : 'ignores hours', o.avoidTolls ? 'no tolls' : '', o.returnToLab ? 'ends at lab' : 'ends at last stop'].filter(Boolean).join(', ');
}

/** The form fields, ids prefixed so two forms never clash. */
export function optionFields(o, p = 'o') {
  return `<div class="opt-form">
    <label class="f">Route order<select id="${p}Style">
      <option value="normal" ${o.style !== 'farthest' ? 'selected' : ''}>Best order (Google decides)</option>
      <option value="farthest" ${o.style === 'farthest' ? 'selected' : ''}>Farthest stop first, then work back to the lab</option></select></label>
    <label class="f">Plan for<select id="${p}Goal"><option value="fast" ${o.fastest ? 'selected' : ''}>Fastest route</option><option value="short" ${o.fastest ? '' : 'selected'}>Fewest miles</option></select></label>
    <label class="row small"><input type="checkbox" id="${p}Hours" ${o.hours ? 'checked' : ''}> Account for office hours</label>
    <label class="row small"><input type="checkbox" id="${p}Tolls" ${o.avoidTolls ? 'checked' : ''}> No tolls</label>
    <label class="row small"><input type="checkbox" id="${p}Lab" ${o.returnToLab ? 'checked' : ''}> End back at the lab</label>
  </div>`;
}

export function readFields(p = 'o') {
  const v = (id) => document.getElementById(p + id);
  return { style: v('Style').value === 'farthest' ? 'farthest' : 'normal', fastest: v('Goal').value === 'fast', hours: v('Hours').checked, avoidTolls: v('Tolls').checked, returnToLab: v('Lab').checked };
}

/**
 * who: a driver's email, or '*' for every driver on the road today (dispatch only).
 * mine: the driver editing their own route.
 */
export function optionsModal(who, { mine = false } = {}) {
  const all = who === '*';
  const o = all ? resolveOptions({ lab: S.lab, day: S.day }) : routeOpt(who);
  const name = all ? 'every route' : mine ? 'your route' : `${driverName(who)}'s route`;
  const n = all ? workingDrivers().length : 0;
  modal(`<h2>Options for ${esc(name)}</h2>
    <p class="small muted">${all ? `Sets these for all ${n} driver${n === 1 ? '' : 's'} on the road today. Each driver's everyday defaults stay as they are.` : 'For today. Farthest first plans the drive out to the stop farthest from the lab, then works back.'}</p>
    ${optionFields(o, 'o')}
    ${all ? '' : `<label class="row small"><input type="checkbox" id="oSaveDefault"> Also make these ${mine ? 'my' : `${esc(driverName(who))}'s`} everyday default</label>`}
    <div class="row end"><button class="btn ghost" data-act="closeModal">Cancel</button>
      <button class="btn" data-act="saveOpts" data-who="${esc(who)}" data-replan="0">Save</button>
      <button class="btn primary" data-act="saveOpts" data-who="${esc(who)}" data-replan="1">Save and re-plan</button></div>`);
}

export { labDefaults };
